import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";

export class ApqSourceTypeService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/apqsourcetype`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.filter(x => x.active)//.sort((a, b) => (a.description < b.description ? -1 : 1))
  }
  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/apqsourcetype/${id}`;
    return await super.getRequest<Model>(url, opts);
  }
}
